type Paq = (string | number | Record<string, any>)[];

// safe push
function push(cmd: Paq) {
    (window as any)._paq = (window as any)._paq || [];
    (window as any)._paq.push(cmd);
}

/** Optional user id (NOT an email) */
export function matomoSetUserId(userId: string) {
    if (!userId) return;
    push(['setUserId', userId]);
}
export function matomoClearUserId() {
    push(['resetUserId']);
}

/** Track SPA page views on route change */
export function trackPageView(path?: string) {
    if (path) push(['setCustomUrl', path]);
    push(['trackPageView']);
}

/** Track site search (shows in Behavior → Site Search) */
export function trackSiteSearch(query: string, category = '', resultsCount?: number) {
    if (!query) return;
    // resultsCount must be a number; default to 0 if unknown
    push(['trackSiteSearch', query, category, resultsCount ?? 0]);
}

/** Generic event */
export function trackEvent(category: string, action: string, name?: string, value?: number) {
    const args: Paq = ['trackEvent', category, action];
    if (name != null) args.push(name);
    if (typeof value === 'number') args.push(value);
    push(args);
}
